import { s } from '../constants/styles';

export default function ExerciseForm({ form, setForm, onSave, onCancel, dayColor, isNew }) {
  return (
    <div style={{ padding: 14, borderRadius: 12, background: "rgba(79,143,255,0.04)", border: "1px solid rgba(79,143,255,0.12)", marginBottom: 6 }}>
      <input value={form.name || ""} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
        placeholder="Exercise name" style={{ ...s.inp, fontSize: 15, marginBottom: 10, padding: "10px 12px" }} />
      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <div style={{ flex: 1 }}>
          <div style={s.label}>SETS</div>
          <input type="number" inputMode="numeric" value={form.sets ?? ""} onChange={e => setForm(f => ({ ...f, sets: e.target.value }))}
            style={{ ...s.inp, textAlign: "center", padding: "8px 0", fontSize: 16 }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={s.label}>REP MIN</div>
          <input type="number" inputMode="numeric" value={form.rLo ?? ""} onChange={e => setForm(f => ({ ...f, rLo: e.target.value }))}
            style={{ ...s.inp, textAlign: "center", padding: "8px 0", fontSize: 16 }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={s.label}>REP MAX</div>
          <input type="number" inputMode="numeric" value={form.rHi ?? ""} onChange={e => setForm(f => ({ ...f, rHi: e.target.value }))}
            style={{ ...s.inp, textAlign: "center", padding: "8px 0", fontSize: 16 }} />
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button onClick={() => setForm(f => ({ ...f, compound: true, inc: 5 }))} style={{
          flex: 1, padding: "10px 0", borderRadius: 10, fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
          background: form.compound ? "rgba(79,143,255,0.15)" : "var(--bg-2)", color: form.compound ? "var(--accent)" : "var(--text-3)",
        }}>Compound (+5lb)</button>
        <button onClick={() => setForm(f => ({ ...f, compound: false, inc: 2.5 }))} style={{
          flex: 1, padding: "10px 0", borderRadius: 10, fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
          background: !form.compound ? "rgba(79,143,255,0.15)" : "var(--bg-2)", color: !form.compound ? "var(--accent)" : "var(--text-3)",
        }}>Isolation (+2.5lb)</button>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={onCancel} style={{ ...s.btnG, flex: 1, padding: "12px 0", fontSize: 14, fontFamily: "inherit" }}>Cancel</button>
        <button onClick={onSave} style={{ ...s.btnP, flex: 2, padding: "12px 0", fontSize: 14, fontFamily: "inherit" }}>
          {isNew ? "Add Exercise" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}
